<template>
  <div class="comp-bao2">
    <h1>home pdaged</h1>
    {{ $store.getters['test'] }}
    {{ $store.getters['moduleA/moduleState'] }}
    {{ $.handleAssetsUrl('/sfsf.png') }}
    <!-- <img src="../assets/logo.png" alt=""> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  async mounted() {
    let result = await this.$http.get('/home/banner');
    console.log('result:', result);
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
</style>
